import { IMAGE_LOADER, ImageLoaderConfig } from '@angular/common';
import { inject } from '@angular/core';

import { EnvironmentConfig } from '../client-config';

export function provideImageLoader() {
    return [
        {
            provide: IMAGE_LOADER,
            useFactory: () => {
                const env = inject(EnvironmentConfig);

                return (config: ImageLoaderConfig) => {
                    const baseUrl = `https://scmedia${env.configuration.DOMAIN}/$-$`;
                    if (config.src.includes(baseUrl)) {
                        const quality = config.loaderParams?.quality ?? 85;
                        const width = config.width ?? 480;
                        const imgId = config.src.substring(config.src.indexOf('/$-$/') + '/$-$/'.length);
                        return `https://scmedia${env.configuration.DOMAIN}/cdn-cgi/image/width=${width},quality=${quality}/$-$/${imgId}`;
                    }
                    return config.src;
                };
            },
        },
    ];
}
